<template>
    <div class="page--login">
        <div class="container">
            <div v-show="!isLoading && !resetSuccess">
                <div class="grid desktop--horizontal--center">

                    <div class="grid__item desktop--push--4 desktop--8">
                        <h1 class="title--3">{{ $t("reset-password") }}</h1>
                        <p>{{ $t("enter-a-new-password") }}</p>
                        <br />
                    </div>

                    <div class="grid__item desktop--12">
                        <form
                            class="page--login__form form"
                            action="#"
                            @submit.prevent="submitForm">

                            <div class="grid">
                                <div class="grid__item desktop--push--4 desktop--4">

                                    <div
                                        class="field field--text">
                                        <label
                                            class="field__label field--text__label"
                                            for="field-password">{{ $t("password") }}</label>
                                        <input
                                            required
                                            name="password"
                                            :data-label="$t('password')"
                                            v-model="password"
                                            id="field-password"
                                            class="field__input field--text__input"
                                            :class="(error.errors !== undefined && error.errors['password'] !== undefined && error.errors['password'].length > 0) ? 'field__input--error': ''"
                                            :type="(displayPassword === false) ? 'password' : 'text'"
                                        />
                                        <p
                                            id="field-error-password"
                                            v-if="error.errors !== undefined && error.errors['password'] !== undefined && error.errors['password'].length > 0"
                                            class="field__message--error"
                                        >
                                            {{ error.errors['password'][0] }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="grid desktop--vertical--centered">
                                <div class="grid__item desktop--push--4 desktop--4">

                                    <div
                                        class="field field--text">
                                        <label
                                            class="field__label field--text__label"
                                            for="field-confirm-password">{{ $t("confirm-password") }}</label>
                                        <input
                                            required
                                            name="confirmPassword"
                                            :data-label="$t('confirm-password')"
                                            v-model="confirmPassword"
                                            id="field-confirm-password"
                                            class="field__input field--text__input"
                                            :class="(error.errors !== undefined && error.errors['confirmPassword'] !== undefined && error.errors['confirmPassword'].length > 0) ? 'field__input--error': ''"
                                            :type="(displayPassword === false) ? 'password' : 'text'"
                                        />
                                        <p
                                            id="field-error-password"
                                            v-if="error.errors !== undefined && error.errors['confirmPassword'] !== undefined && error.errors['confirmPassword'].length > 0"
                                            class="field__message--error"
                                        >
                                            {{ error.errors['confirmPassword'][0] }}
                                        </p>
                                    </div>
                                </div>
                                <transition name="fade">
                                    <div
                                        v-if="password && confirmPassword"
                                        class="grid__item desktop--4">
                                        <div class="field--checkbox field--checkbox--inline">
                                            <input
                                                type="checkbox"
                                                v-model="displayPassword"
                                                class="field--checkbox__input"
                                                value="true"
                                                id="field-display-password">
                                            <label
                                                for="field-display-password"
                                                class="field--checkbox__label">{{ $t("display-password") }}</label>
                                        </div>
                                    </div>
                                </transition>
                            </div>

                            <div class="grid desktop--vertical--centered">
                                <div class="grid__item desktop--push--4 desktop--4">
                                    <div class="field">
                                        <button class="button button--primary button--fullwidth">{{ $t("validate") }}</button>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

            <div v-if="!isLoading && resetSuccess">
                <div class="grid__item desktop--push--4 desktop--8">
                    <h1 class="title--3">{{ $t("the-password-was-successfully-reset") }}</h1>
                    <p>{{ $t("you-can-login-with-new-credential") }}</p>
                    <router-link
                        class="button button--primary"
                        to="/login">{{ $t("login") }}</router-link>
                </div>
            </div>

            <div v-if="isLoading">
                <HorizontalBubbleLoader />
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import HorizontalBubbleLoader from "@/components/loaders/HorizontalBubbleLoader.vue";

import { userPasswordResetUpdate } from "@/utils/api/usersApi.js";
import { purify } from "@/utils/helpers/string.js";
import { setCookie } from "@/utils/helpers/cookie";
import { validateForm } from "@/utils/helpers/validate-form.js";

export default {
    name: "ForgotPassword",
    components: {
        HorizontalBubbleLoader
    },
    props: {
        token: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            isLoading: false,
            resetSuccess: false,
            email: "",
            password: "",
            confirmPassword: "",
            displayPassword: false,
            error: "",
        };
    },
    computed: {
        user() {
            return {
                password: this.password,
                token: this.token
            };
        },
    },
    mounted: function() {
    },
    methods: {
        submitForm() {
            const isFormValid = validateForm(this.$el);

            if(isFormValid.value === true) {
                this.error = "";

                if (this.password === this.confirmPassword) {
                    userPasswordResetUpdate(this.user).then((res) => {

                        this.isLoading = true;

                        if (res.data && res.data.status === "ok") {
                            // console.log("user login", res.data);

                            /*const loginInfo = {
                                "id": res.data.id,
                                "token": res.data.token
                            };*/
                            this.resetSuccess = true;
                            this.isLoading = false;

                        } else {
                            this.isLoading = false;
                            // Handle Error
                            let message = this.$t("a-server-error-occured-please-try-later");

                            switch (res.status) {
                            case 401:
                                message = this.$t("wrong-username-password");
                                break;
                            }

                            this.$notificationsBar.alert(message, {type: "warning"});
                        }
                    });
                } else {
                    this.error = {
                        "message":"the_given_data_was_invalid",
                        "errors":{
                            "confirmPassword": [this.$t("password-doesnt-match")]
                        }
                    };

                    //Set focus to first error field for screen reader
                    if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                        let errorFieldName = Object.keys(this.error.errors)[0];
                        let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                        if(errorField) {
                            errorField.focus();
                        }
                    }
                }

            } else {
                // There are some errors
                this.error = isFormValid.error;

                //Set focus to first error field for screen reader
                if(this.error.errors !== undefined && Object.keys(this.error.errors).length > 0) {
                    let errorFieldName = Object.keys(this.error.errors)[0];
                    let errorField = document.getElementById("field-" + errorFieldName.toLowerCase());
                    if(errorField) {
                        errorField.focus();
                    }
                }
            }
        }
    }
};
</script>